module.exports = __webpack_public_path__ + "img/ctrl-c-stub-up-1.49b4f779.svg";